import React from 'react';
import { Input, Button } from '@bcmi-labs/react-components';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';

import AlertBox from '../../common/AlertBox';
import PropTypes from 'prop-types';
import './SendParentEmailForm.scss';

const SendParentEmailForm = (props) => {
  const { t } = useTranslation('sendParentEmail');

  const { handleSubmit, errors, control } = useForm();
  const { onSubmit, error, loading, invalidEmail } = props;

  return (
    <section className="send-parent-email">
      <h1 className="arduino-typography-large">{t('sendParentEmail:title')}</h1>

      <p className="description">{t('sendParentEmail:description')}</p>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="form-row">
          <Controller
            as={Input}
            name="email"
            control={control}
            defaultValue=""
            label={t('sendParentEmail:email')}
            error={errors.email && errors.email.message}
            isRequired
            rules={{
              required: t('sendParentEmail:fieldRequired'),
              pattern: {
                value: /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/,
                message: t('sendParentEmail:emailInvalid'),
              },
              validate: {
                noUserEmail: (value) =>
                  invalidEmail ? value !== invalidEmail || t('sendParentEmail:noUserEmail') : true,
              },
            }}
          />
        </div>
        <div className="form-row">
          <Controller
            as={Input}
            name="confirmEmail"
            control={control}
            defaultValue=""
            label={t('sendParentEmail:confirmEmail')}
            error={errors.confirmEmail && errors.confirmEmail.message}
            isRequired
            rules={{
              required: t('sendParentEmail:fieldRequired'),
              pattern: {
                value: /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/,
                message: t('sendParentEmail:emailInvalid'),
              },
              validate: (value) => {
                return value === control.getValues('email') || t('sendParentEmail:emailMismatch');
              },
            }}
          />
        </div>
        {error ? <AlertBox message={error} /> : null}
        <Button type="submit" loading={loading}>
          {t('sendParentEmail:submitText')}
        </Button>
      </form>
      <div className="spacer"></div>
    </section>
  );
};

SendParentEmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  invalidEmail: PropTypes.string,
  loading: PropTypes.bool,
};

export default SendParentEmailForm;
